import { render, staticRenderFns } from "./forkLiftTypeManagePop.vue?vue&type=template&id=1c24a44a"
import script from "./forkLiftTypeManagePop.vue?vue&type=script&lang=js"
export * from "./forkLiftTypeManagePop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c24a44a')) {
      api.createRecord('1c24a44a', component.options)
    } else {
      api.reload('1c24a44a', component.options)
    }
    module.hot.accept("./forkLiftTypeManagePop.vue?vue&type=template&id=1c24a44a", function () {
      api.rerender('1c24a44a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/heq/forkLiftTypeManagePop.vue"
export default component.exports